// Permissions
const Permissions = {
  Pages: {
    /**
     * Allows access to the main assets browser page
     */
    ASSETS: 'assets',
    /**
     * Allows access to the dashboard page
     */
    DASHBOARD: 'assets_dashboard',
  },

  Files: {
    /**
     * Allows downloading asset files
     */
    DOWNLOAD: 'assets_files_download',
    /**
     * Allows moving asset files
     */
    MOVE: 'assets_files_move',
  },

  Folders: {
    /**
     * Allows creating asset folders
     */
    CREATE: 'assets_folders_create',
    /** Allows advanced creation of asset folders */
    CREATE_ADVANCED: 'assets_folders_create_advanced',
  },
};

export default Permissions;
